<template>
  <div class="row">
    <div class="col-12">
      <card
        v-if="permisosPedido.acceder"
        card-body-classes="table-full-width"
        no-footer-line
      >
        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        >
          <!-- Botón Nuevo -->
          <router-link :to="{ name: 'Nuevo Pedido' }" class="col-2">
            <n-button type="primary" round>
              <i slot="label" class="now-ui-icons ui-1_simple-add"></i>

              {{ $t("app.buttons.new") }}
            </n-button>
          </router-link>

          <!-- Buscar Número Pedido -->
          <div class="col-2">
            {{ $t("app.modules.orders.headers.order_number") }}

            <fg-input>
              <el-input
                type="text"
                class="mb-2"
                clearable
                style="width: 200px"
                :placeholder="$t('app.modules.orders.headers.order_number')"
                v-model="searchNumPedido"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>

          <!-- Buscar Razón Social -->
          <div class="col-2">
            {{ $t("app.modules.orders.headers.business_name") }}

            <fg-input>
              <el-input
                type="text"
                class="mb-2"
                clearable
                style="width: 200px"
                :placeholder="$t('app.modules.orders.headers.business_name')"
                v-model="searchRazonSocial"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>

          <!-- Fecha Creación -->
          <div class="col-2">
            {{ $t("app.modules.orders.filters.created_date_ini") }}

            <fg-input>
              <el-date-picker
                type="date"
                placeholder="Date Picker"
                v-model="iniCreateDate"
              >
              </el-date-picker>
            </fg-input>
          </div>

          <!-- Fecha Creación -->
          <div class="col-2">
            {{ $t("app.modules.orders.filters.created_date_end") }}

            <fg-input>
              <el-date-picker
                type="date"
                placeholder="Date Picker"
                v-model="endCreateDate"
              >
              </el-date-picker>
            </fg-input>
          </div>

          <!-- Estado Pedido -->
          <div class="col-2">
            {{ $t("app.modules.orders.headers.status") }}

            <el-select
              type="primary"
              v-model="currState"
              filterable
              :placeholder="$t('app.modules.orders.headers.status')"
            >
              <el-option label="Todos" value=""></el-option>
              <el-option
                v-for="item in this.status"
                :key="item.idEstadoPedido"
                :label="item.estadoPEdido"
                :value="item.estadoPEdido"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        >
          <!-- Clientes -->
          <div class="col-2">
            {{ $t("app.modules.customers.title") }}

            <el-select
              type="primary"
              v-model="currClient"
              filterable
              :placeholder="$t('app.modules.orders.headers.status')"
            >
              <el-option label="Todos" value=""></el-option>
              <el-option
                v-for="item in this.clientes"
                :key="item.idClienteSAP"
                :label="item.razonSocial"
                :value="item.idClienteSAP"
              >
              </el-option>
            </el-select>
          </div>

          <!-- Fecha Autorización -->
          <div class="col-2">
            {{ $t("app.modules.orders.filters.auth_date_ini") }}

            <fg-input>
              <el-date-picker
                type="date"
                placeholder="Date Picker"
                v-model="iniAuthDate"
              >
              </el-date-picker>
            </fg-input>
          </div>

          <!-- Fecha Autorización -->
          <div class="col-2">
            {{ $t("app.modules.orders.filters.auth_date_end") }}

            <fg-input>
              <el-date-picker
                type="date"
                placeholder="Date Picker"
                v-model="endAuthDate"
              >
              </el-date-picker>
            </fg-input>
          </div>

          <!-- Vendedor -->
          <div class="col-2">
            {{ $t("app.modules.orders.headers.salesman") }}

            <fg-input>
              <el-input
                type="text"
                class="mb-2"
                clearable
                style="width: 200px"
                :placeholder="$t('app.modules.orders.headers.salesman')"
                v-model="searchSalesman"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>

          <!-- Usuario Servicio a Cliente -->
          <div class="col-2">
            {{ $t("app.modules.orders.headers.customer_service") }}

            <fg-input>
              <el-input
                type="text"
                class="mb-2"
                clearable
                style="width: 200px"
                :placeholder="$t('app.modules.orders.headers.customer_service')"
                v-model="searchCS"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
        </div>

        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.orders.title") }}
            </h4>
          </div>

          <el-table stripe style="width: 100%" :data="queriedData">
            <el-table-column
              :label="$t('app.modules.orders.headers.created_date')"
              min-width="220"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.fechaCreacionPedido }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.auth_date')"
              min-width="250"
              sortable
            >
              <template slot-scope="scope">
                {{
                  scope.row.fechaConfirmacionPedido == "1900-01-01"
                    ? ""
                    : scope.row.fechaConfirmacionPedido
                }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.status')"
              min-width="220"
              sortable
            >
              <template slot-scope="scope">
                {{
                  scope.row.estadoPedido
                }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.purchase_order')"
              min-width="220"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.ordenCompraCliente }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.business_name')"
              min-width="240"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.razonSocial }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.order_number')"
              min-width="230"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.numPedidoSAP }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.salesman')"
              min-width="310"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.nombre }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.orders.headers.customer_service')"
              min-width="350"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.nombreUsuarioServicioCliente }}
              </template>
            </el-table-column>

            <el-table-column min-width="200">
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="300"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          showTracking(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.orders.tracking.name") }}
                      </n-button>
                      <!--<n-button
                        v-if="
                          props.row.idEstadoPedido !== constEstadoPedido.INICIAL
                        "
                        @click.native="resendConfirmation(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.resend_order") }}
                      </n-button>
                      <n-button
                        @click.native="record(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.record") }}
                      </n-button>-->
                      <!--<n-button v-if="props.row.idEstadoPedido !== constEstadoPedido.DEVUELTO_VALIDACION
                        && props.row.idEstadoPedido !== constEstadoPedido.DECLINADO"
                        @click.native="returnOrder(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.return_order") }}
                      </n-button>
                      <n-button
                        v-if="props.row.idEstadoPedido !== constEstadoPedido.DECLINADO"
                        @click.native="cancelOrder(props.row)"
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.form.cancel_order") }}
                      </n-button>-->
                      <n-button
                        @click.native="
                          showDocs(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.orders.documents.documentation") }}
                      </n-button>
                      <n-button
                        @click.native="
                          showDetails(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.orders.details.single") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>

        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>

          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
    </div>
    <devolver-pedido-modal />
    <historial-pedido-modal />
  </div>
</template>

<script>
import Fuse from "fuse.js";
import DevolverPedidoModal from "./devolverPedidoModal";
import HistorialPedidoModal from "./historialPedidoModal";
import ConstEstadoPedido from "@/models/pedidos/ConstEstadoPedido";
import { getResponse } from "@/util/utilities";
import { mapState } from "vuex";

export default {
  components: {
    DevolverPedidoModal,
    HistorialPedidoModal
  },
  computed: {
    ...mapState(["modules"]),
    queriedData() {
      let result = this.tableData;

      // filter by create date
      result =
        this.iniCreateDate > new Date("1900-01-01") &&
        this.endCreateDate > new Date("1900-01-01")
          ? (result = result.filter(
              d =>
                new Date(d.fechaCreacionPedido) >= this.iniCreateDate &&
                new Date(d.fechaCreacionPedido) <= this.endCreateDate
            ))
          : result;

      // filter by confirmation date
      result =
        this.iniAuthDate > new Date("1900-01-01") &&
        this.endAuthDate > new Date("1900-01-01")
          ? (result = result.filter(
              d =>
                (new Date(d.fechaConfirmacionPedido) >= this.iniAuthDate &&
                  new Date(d.fechaConfirmacionPedido) <= this.endAuthDate) ||
                d.fechaConfirmacionPedido == "1900-01-01"
            ))
          : result;

      // filter by business name
      result =
        this.searchRazonSocial.length > 0
          ? result.filter(d =>
              d.razonSocial
                .toLowerCase()
                .includes(this.searchRazonSocial.toLowerCase())
            )
          : result;

      // filter by order number
      result =
        this.searchNumPedido.length > 0
          ? result.filter(d =>
              d.numPedidoSAP
                .toLowerCase()
                .includes(this.searchNumPedido.toLowerCase())
            )
          : result;

      // filter by salesman
      result =
        this.searchSalesman.length > 0
          ? result.filter(d =>
              d.nombre.toLowerCase().includes(this.searchSalesman.toLowerCase())
            )
          : result;

      // filter by customer service
      result =
        this.searchCS.length > 0
          ? result.filter(d =>
              d.nombreUsuarioServicioCliente
                .toLowerCase()
                .includes(this.searchCS.toLowerCase())
            )
          : result;

      // filter by status
      result =
        this.currState.length > 0
          ? result.filter(d =>
              d.estadoPedido
                .toLowerCase()
                .includes(this.currState.toLowerCase())
            )
          : result;

      // filter by client id SAP
      result =
        this.currClient != 0
          ? result.filter(
              d => d.idClienteSAP.toLowerCase() == this.currClient.toLowerCase()
            )
          : result;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      permisosPedido: {
        acceder: false
      },
      currState: "",
      currClient: "",
      tableData: [],
      searchQuery: "",
      searchNumPedido: "",
      searchRazonSocial: "",
      searchSalesman: "",
      searchCS: "",
      searchedData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      createDate: new Date(2020, 1, 1),
      iniCreateDate: new Date(2020, 1, 1),
      endCreateDate: new Date(2020, 12, 1),
      authDate: new Date(2020, 1, 1),
      iniAuthDate: new Date(2020, 1, 1),
      endAuthDate: new Date(2020, 12, 1),
      status: [],
      clientes: [],
      constEstadoPedido: new ConstEstadoPedido()
    };
  },
  async created() {
    await this.PermisosPedidos();
  },
  async mounted() {
    EventBus.$on("reload-items", () => {
      this.init();
    });
  },
  methods: {
    async PermisosPedidos() {
      var permisos = [];
      for (var i = 0; i < this.modules.length; i++) {
        if (this.modules[i].nombreModulo === "Pedidos") {
          permisos = this.modules[i].claimsModule;
          break;
        }
      }
      for (var con = 0; con < permisos.length; con++) {
        console.log(permisos[con].active);
        if (permisos[con].permiso == "Acceder" && permisos[con].active) {
          this.permisosPedido.acceder = true;
        }
      }
      await this.verificarEntrada();
    },
    async verificarEntrada() {
      if (this.permisosPedido.acceder) {
        this.init();
      } else {
        this.$alert(this.$t("app.promps.permission_error"), "", {
          confirmButtonText: this.$t("app.buttons.accept"),
          callback: action => {
            console.log("Ventana cerrada");
            this.$router.push({
              name: "Home"
            });
          }
        });
      }
    },
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getStatus();
      await this.getItems();
      await this.getClients();
      this.$swal.close();
    },
    async getStatus() {
      await this.$http.get(route("Pedidos/getEstadosPedido")).then(
        response => {
          if (response.body.code === 200) {
            this.status = response.body.estados;
          } else {
            console.log(response.body);
            // this.processError(response.body)
          }
        },
        error => {
          console.error(error);
          // this.processError(error)
        }
      );
    },
    async getItems() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.post(route("Pedidos/ListaPedidos"), params).then(
        response => {
          if (response.body.code === 200) {
            console.log(response.body.pedidos);
            this.tableData = response.body.pedidos;
          } else {
            console.log(response.body);
            // this.processError(response.body)
          }
        },
        error => {
          console.error(error);
          // this.processError(error)
        }
      );
    },
    returnOrder(row) {
      EventBus.$emit("devolverPedido", row);
    },
    cancelOrder(row) {
      EventBus.$emit("declinarPedido", row);
    },
    record(row) {
      EventBus.$emit("historialPedido", row);
    },
    async resendConfirmation(row) {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      let data = new FormData();
      data.append("idPedido", row.idPedido);

      let request = await this.$http.post(
        route("Pedidos/enviarPedidoConfirmacion"),
        data
      );
      let response = getResponse(request);

      if (response) {
        this.init();
        this.notifyMessage("success", this.$t("app.promps.save_success"));
      } else this.notifyMessage("danger", this.$t("app.promps.error"));

      this.$swal.close();
    },
    async getClients() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.get(route("Clientes/getClientes")).then(
        response => {
          if (response.body.code === 200) {
            this.clientes = response.body.clientes;
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    showDocs(index, row, ref) {
      this.$refs[ref].doClose();
      this.$router.push({
        name: "Partidas pedido",
        params: { idPedido: row.idPedido }
      });
    },
    showDetails(index, row, ref) {
      this.$refs[ref].doClose();
      this.$router.push({
        name: "Detalle pedido",
        params: { idPedido: row.idPedido }
      });
    },
    showTracking(index, row, ref) {
      this.$refs[ref].doClose();
      this.$router.push({
        name: "Tracking pedido",
        params: { idPedido: row.idPedido }
      });
    }
  }
};
</script>
